import { IAnyModelType, types } from 'mobx-state-tree';
import {
  CategoryStatSingleItem,
  CategoryStatSingleItemProps,
} from './category-stat-single-item';

export interface CategorySingleItemProps {
  id: string;
  name: string;
  need_want?: string;
  type?: string;
  category_stat: CategoryStatSingleItemProps;
  subcategories?: CategorySingleItemProps[];
  income_expenditure?: string;
}

export const CategorySingleItem = types.model({
  id: types.string,
  name: types.string,
  need_want: types.maybe(types.string),
  type: types.maybe(types.string),
  category_stat: CategoryStatSingleItem,
  subcategories: types.maybe(
    types.array(types.late((): IAnyModelType => CategorySingleItem))
  ),
  income_expenditure: types.maybe(types.string),
});
